import { Component, inject, Signal } from '@angular/core';
import { slideInOutAnimation } from '../../../animations/slide.animation';
import { ToastService } from '../../../services/toast.service';
import { CloseButtonComponent } from '../../atoms/close-button/close-button.component';
import { IconComponent } from '../../atoms/icon/icon.component';
import { Toast, ToastTypeEnum } from './toast.type';

@Component({
  animations: [slideInOutAnimation],
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  imports: [IconComponent, CloseButtonComponent],
})
export class ToastComponent {
  private toastService: ToastService = inject(ToastService);
  public toasts: Signal<Toast[]> = this.toastService.getToasts();
  protected readonly ToastTypeEnum = ToastTypeEnum;

  deleteToast(id: number): void {
    this.toastService.removeToast(id);
  }
}
